export const SET_FILTER_DATA = 'SET_FILTER_DATA';
export const SET_SELECTED_FILTER = 'SET_SELECTED_FILTER';
export const SET_IS_SECTION_TYPE = 'SET_IS_SECTION_TYPE';
export const SET_IS_VERIFY_TYPE = 'SET_IS_VERIFY_TYPE';
export const SET_HAS_FILES = 'SET_HAS_FILES';
export const SET_CATEGORY = 'SET_CATEGORY';
export const SET_SELECTED_CATEGORY = 'SET_SELECTED_CATEGORY';
export const SET_HAS_FILTER = 'SET_HAS_FILTER';
// export const SET_HAS_IMAGE = 'SET_HAS_IMAGE';
// export const SET_HAS_AUDIO = 'SET_HAS_AUDIO';
export const RESET_FILTERS = 'RESET_FILTERS';